module.exports = __webpack_public_path__ + "img/PART-B.e6e06c9e.png";